module.exports = __webpack_public_path__ + "img/mongo.668931e0.svg";